module.exports = "/img/iqos-icon.svg?98597bb234669030267123715afa4e76";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/iqos-icon.svg
// module id = ohvu
// module chunks = 83